/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import { NoProducts } from '@/components/NoProducts'
import useGetSearchEvents from '@/scenes/Search/analytics/useGetSearchEvents'
import AnalyticsSearchLoad from '@/scenes/Search/components/AnalyticsSearchLoad'
import { ItemTemplate } from '@/shared/container'
import getSelectedFilters from '@/useCases/filters/getSelectedFilters'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'
import { useEffect } from 'react'
const NotFound = () => {
  const { filtersPathInfo } = useHeaderDataContext()
  const { sendNoSearchResultsEvent } = useGetSearchEvents()

  useEffect(() => {
    sendNoSearchResultsEvent({
      searchTerm: filtersPathInfo?.searchTerm,
      customParams: getSelectedFilters(filtersPathInfo),
    })
  }, [])

  return (
    <ItemTemplate>
      <NoProducts />
      <AnalyticsSearchLoad />
    </ItemTemplate>
  )
}

export default NotFound
